"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var material_1 = require("@mui/material");
var makeSupplierCardStyling = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var isClickable = _a.isClickable;
    var _l = (0, react_1.useTheme)(), breakpoints = _l.breakpoints, mvf = _l.mvf;
    var fontSize = mvf.fontSize, typography = mvf.typography, palette = mvf.palette, filters = mvf.filters, border = mvf.border;
    var weight = typography.weight;
    return {
        container: __assign({}, (!isClickable && {
            cursor: 'default',
            pointerEvents: 'none',
        })),
        badge: (0, react_1.css)((_b = {
                position: 'absolute',
                top: 0,
                left: 0,
                backgroundColor: palette.text.primaryTextColor,
                padding: '1px 14px',
                borderTopLeftRadius: border.radius
            },
            _b[breakpoints.up('tabletSmall')] = {
                padding: '5px 16px 3px 16px',
            },
            _b)),
        badgeText: (0, react_1.css)((_c = {
                fontFamily: typography.fontFamily,
                letterSpacing: 'inherit',
                color: palette.text.continueButtonTextColor,
                fontSize: fontSize.mini,
                fontWeight: weight.thick
            },
            _c[breakpoints.up('tabletSmall')] = {
                fontSize: fontSize.small,
            },
            _c)),
        supplierName: (0, react_1.css)({
            color: palette.text.primaryTextColor,
        }),
        supplierNameText: (0, react_1.css)({
            fontFamily: typography.fontFamily,
            letterSpacing: 'inherit',
            color: palette.text.primaryTextColor,
            fontSize: fontSize.medium,
            fontWeight: weight.thick,
        }),
        buttonContainer: (0, react_1.css)((_d = {
                maxWidth: 230,
                height: 44,
                margin: '10px auto',
                paddingLeft: 10,
                paddingRight: 10
            },
            _d[breakpoints.up('tabletSmall')] = {
                height: 55,
            },
            _d)),
        cardContainer: (0, react_1.css)((_e = {
                minHeight: 260,
                paddingTop: 10,
                paddingBottom: 10
            },
            _e[breakpoints.up('tabletSmall')] = {
                minHeight: 150,
            },
            _e)),
        logoGridContainer: (0, react_1.css)((_f = {
                height: '100%',
                margin: 'auto',
                paddingBottom: 10,
                width: '90%',
                borderBottom: 'solid',
                borderBottomColor: (0, material_1.lighten)(palette.component.answerUnselectedColor, filters.lighten.medium),
                borderBottomWidth: border.width.thin
            },
            _f[breakpoints.up('tabletSmall')] = {
                borderBottom: 'none',
                padding: 0,
                minHeight: 120,
            },
            _f)),
        logoGridItem: (0, react_1.css)({
            width: 100,
            maxHeight: 50,
        }),
        rightCheckbox: (0, react_1.css)((_g = {
                display: 'none'
            },
            _g[breakpoints.up('tabletSmall')] = {
                display: 'block',
                margin: 0,
                padding: 0,
            },
            _g)),
        rightText: (0, react_1.css)((_h = {
                fontFamily: typography.fontFamily,
                letterSpacing: 'inherit',
                color: palette.component.answerSelectedColor,
                fontSize: fontSize.compact,
                fontWeight: weight.thick,
                textAlign: 'center'
            },
            _h[breakpoints.up('tabletSmall')] = {
                fontSize: fontSize.medium,
            },
            _h)),
        textGridItem: (0, react_1.css)((_j = {
                width: '100%',
                height: '100%',
                margin: '10px auto',
                paddingLeft: 10,
                paddingRight: 10
            },
            _j[breakpoints.up('tabletSmall')] = {
                paddingLeft: 10,
                paddingRight: 5,
                borderLeft: 'solid',
                borderLeftColor: (0, material_1.lighten)(palette.component.answerUnselectedColor, filters.lighten.medium),
                borderLeftWidth: border.width.thin,
                minHeight: 120,
            },
            _j)),
        topRightCheckbox: (0, react_1.css)((_k = {
                position: 'absolute',
                top: 0,
                right: 0,
                margin: 10,
                padding: 0,
                display: 'block'
            },
            _k[breakpoints.up('tabletSmall')] = {
                display: 'none',
            },
            _k)),
    };
};
exports.default = makeSupplierCardStyling;
//# sourceMappingURL=makeSupplierCardStyling.js.map